export const isPublicPath = (isLoginAtRegistrationPage: string) => {
    const currentPath = window.location.pathname.split('/');
    const publicPath = ['', 'forget-nickname', 'imprint', 'privacyPolicy', 'reset-password'];

    return (currentPath.length > 1 && publicPath.includes(currentPath[1])) || isLoginAtRegistrationPage === '1';
};
